module.exports = __webpack_public_path__ + "img/mentor-badge.86f94222.svg";